module.exports = __webpack_public_path__ + "static/img/rank_89.cf57e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_89.png
// module id = F7dm
// module chunks = 1